import { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { baseApiURL } from "../../../baseUrl";
import { FiUser, FiMail, FiBook } from "react-icons/fi";

const AddLibrary = () => {
    const [data, setData] = useState({
        libraryId: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        gender: ""
      });

      const addLibraryProfile = (e) => {
        e.preventDefault();
        if (!data.libraryId || !data.firstName || !data.lastName || !data.email || !data.phoneNumber || !data.gender) {
            toast.error("Please fill in all fields");
            return;
        }
    
        toast.loading("Adding Librarian");
    
        axios
            .post(`${baseApiURL()}/library/details/addDetails`, data) // Send JSON instead of FormData
            .then((response) => {
                toast.dismiss();
                if (response.data.success) {
                    toast.success(response.data.message);
                    // Register the librarian for authentication
                    axios
                        .post(`${baseApiURL()}/library/auth/register`, {
                            loginid: data.libraryId,
                            password: data.libraryId,
                        })
                        .then((res) => {
                            if (res.data.success) {
                                toast.success(res.data.message);
                                resetForm();
                            } else {
                                toast.error(res.data.message);
                            }
                        })
                        .catch((error) => {
                            toast.error(error.response?.data?.message || "An error occurred while registering.");
                        });
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch((error) => {
                toast.dismiss();
                toast.error(error.response?.data?.message || "An error occurred while adding librarian.");
            });
    };
    

      const resetForm = () => {
        setData({
          libraryId: "",
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          gender: ""
        });
      };
    
  return (
    <div className="space-y-6">
      <div className="bento-header-banner flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white flex items-center gap-2">
            <FiBook className="text-indigo-600 dark:text-indigo-400" /> Add New Librarian
          </h1>
          <p className="text-slate-500 dark:text-slate-400 font-medium text-xs mt-0.5">Register a new librarian profile in the system</p>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xs border border-slate-200 dark:border-slate-800 p-6">
        {/* Form */}
        <form onSubmit={addLibraryProfile} className="space-y-6">
          {/* Personal Information Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <FiUser className="text-indigo-600 dark:text-indigo-400 text-base" />
              <h2 className="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-wider">Personal Information</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="firstname" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  First Name *
                </label>
                <input
                  type="text"
                  id="firstname"
                  required
                  value={data.firstName}
                  onChange={(e) => setData({ ...data, firstName: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter first name"
                />
              </div>
              <div>
                <label htmlFor="lastname" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Last Name *
                </label>
                <input
                  type="text"
                  id="lastname"
                  required
                  value={data.lastName}
                  onChange={(e) => setData({ ...data, lastName: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter last name"
                />
              </div>
              <div>
                <label htmlFor="libraryId" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Library ID *
                </label>
                <input
                  type="number"
                  id="libraryId"
                  required
                  value={data.libraryId}
                  onChange={(e) => setData({ ...data, libraryId: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none font-mono"
                  placeholder="Enter library ID"
                />
              </div>
              <div>
                <label htmlFor="gender" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Gender *
                </label>
                <select
                  id="gender"
                  required
                  value={data.gender}
                  onChange={(e) => setData({ ...data, gender: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                >
                  <option value="">Select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
          </div>

          {/* Contact Information Section */}
          <div className="pt-4 border-t border-slate-100 dark:border-slate-800">
            <div className="flex items-center space-x-2 mb-4">
              <FiMail className="text-indigo-600 dark:text-indigo-400 text-base" />
              <h2 className="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-wider">Contact Information</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="email" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  value={data.email}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter email address"
                />
              </div>
              <div>
                <label htmlFor="phoneNumber" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phoneNumber"
                  required
                  value={data.phoneNumber}
                  onChange={(e) => setData({ ...data, phoneNumber: e.target.value })}
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  placeholder="Enter phone number"
                />
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-end space-x-3 pt-6 border-t border-slate-100 dark:border-slate-800">
            <button
              type="button"
              onClick={resetForm}
              className="px-4 py-2.5 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-xl text-xs font-bold transition cursor-pointer"
            >
              Reset Form
            </button>
            <button
              type="submit"
              className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-bold shadow-xs transition cursor-pointer"
            >
              Add Librarian
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddLibrary